/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ContextName = 'connections' | 'files' | 'social_group' | 'comments';

export const ContextName = {
    Connections: 'connections' as ContextName,
    Files: 'files' as ContextName,
    SocialGroup: 'social_group' as ContextName,
    Comments: 'comments' as ContextName
};